import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb64a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "estimate-received-preview tw-h-full tw-w-full tw-flex tw-flex-col tw-gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-rounded-[10px] tw-px-3 tw-py-1 tw-box-border tw-bg-[#f454540d] tw-border-solid tw-border tw-border-[rgba(255,165,0,1)]"
}
const _hoisted_3 = { class: "tw-text-sm tw-border-[rgba(255,165,0,1)] tw-text-left tw-bg-[rgba(255,165,0,0.2) tw-w-[calc(100%-50px)] tw-max-w-full" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "estimate-received-preview__container tw-flex tw-items-start tw-justify-between tw-py-4 tw-box-border tw-border-[0] tw-border-b-[1px] tw-border-[#C5D2F2] tw-border-solid md:!tw-pt-0" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-4 lg:tw-hidden" }
const _hoisted_8 = {
  key: 1,
  class: "tw-gap-10 tw-flex xl:tw-gap-5 lg:tw-flex-col md:!tw-pb-28"
}
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-gap-4 tw-w-[340px] tw-max-w-full lg:tw-w-full" }
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_11 = { class: "lg:tw-flex tw-items-center tw-gap-4 tw-hidden sm:tw-flex-col" }
const _hoisted_12 = { class: "tw-pl-3 tw-pb-2 tw-box-border tw-flex tw-flex-col tw-gap-4 tw-w-[calc(100%_-_340px)] tw-max-w-full lg:tw-w-full lg:tw-pr-0 lg:tw-pl-0" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_14 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start" }
const _hoisted_15 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-8" }
const _hoisted_16 = {
  key: 0,
  class: "tw-bg-white tw-rounded-lg tw-px-4 tw-py-5 tw-shadow-[0px_0px_8px_0px_#0C0F4A14] tw-text-darkBlue tw-text-left"
}
const _hoisted_17 = {
  key: 0,
  class: "tw-flex tw-gap-y-4 tw-gap-x-6 rmd:tw-gap-x-16 tw-flex-wrap"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Emergency call out fee")
], -1))
const _hoisted_19 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Emergency call out rate")
], -1))
const _hoisted_21 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_22 = {
  key: 1,
  class: "tw-flex tw-gap-y-4 tw-gap-x-6 rmd:tw-gap-x-16 tw-flex-wrap"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Video Consulation Fee")
], -1))
const _hoisted_24 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Video Consulation Start Date")
], -1))
const _hoisted_26 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Video Consulation Duration")
], -1))
const _hoisted_28 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Contractor Note")
], -1))
const _hoisted_30 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "modal_wrapper" }
const _hoisted_33 = { class: "main" }
const _hoisted_34 = { class: "loader__content" }
const _hoisted_35 = { class: "switching-text" }
const _hoisted_36 = { class: "loader__icon" }
const _hoisted_37 = ["src"]

import { reactive, computed, getCurrentInstance } from "vue";

import BackButton from "@/core/components/common/BackButton.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import SubContractorList from "@/modules/project/components/common/SubContractorList.vue";
import ContractorDetailsCard from "@/modules/project/components/common/ContractorDetailsCard.vue";
import LabelWithValue from "@/core/components/common/LabelWithValue.vue";
import EstimateReceivedSummaryCard from "@/modules/project/components/common/EstimateReceivedSummaryCard.vue";
import CommercialChip from "@/core/uni-components/Chips/CommercialChip.vue";
import { useRouter } from "vue-router";

import { ref } from "vue";
import projectService from "@/core/services/project.service";
import ServiceAgreementModal from "@/modules/jobs/components/modal/ServiceAgreementModal.vue";
import AcceptProjectEstimateModal from "@/modules/project/modal/AcceptProjectEstimateModal.vue";
import RejectProjectEstimateModal from "@/modules/project/modal/RejectProjectEstimateModal.vue";

import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import projectEstimationService from "@/core/services/project-estimation.service";
import { AgreeTermsConsumerDisclosure } from "@/core/enums/estimateEnum";
import EstimateDetailsModal from "@/modules/project/modal/EstimateDetailsModal.vue";
import {
  ProjectJobStatusEnum,
  ProjectTypesEnum,
} from "@/core/enums/ProjectsEnum";
import EstimateApproveModal from "@/modules/project/modal/EstimateApproveModal.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { onBeforeMount } from "vue";
import JobService from "@/core/services/jobs.service";
import { displayToastMessage } from "@/core/utils/common";
import { WORKSTATION } from "@/store/modules/workstation";
import ErrorRedIcon from "@/core/components/icons/ErrorRedIcon.vue";
import { useRoute } from "vue-router";

const __default__ = {
  name: "EstimateReceivedPreview",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  details: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const route = useRoute();
const store = useStore();
const loading = ref(false);
const isAcceptEstimate = ref(false);
const isRejectEstimate = ref(false);
const isEstimateLoading = ref(false);
const isOpenServiceAgreementModal = ref(false);
const isOpenEstimateDetailsModal = ref(false);
const isEstimateApproved = ref(false);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const switchingText = ref("Loading...");
const currentSelectedTab = ref({ name: "tab1" });
const emergencyCallOutDetails = ref(null) as any;
const acceptEstimateLoader = ref(false);
const tabListItems = ref([
  { name: "tab1" },
  { name: "tab2" },
  { name: "tab3" },
]);
const projectName = computed(() => props.details?.project?.name || "");
const workStationName = computed(
  () =>
    props.details?.project?.projectEstimateAcceptDetails?.workStation?.name ||
    ""
);
const projectEstimate = computed(() => {
  return {
    ...props.details,
    projectEstimateCreator: {
      ...props.details?.workStation?.user,
      workStation: props.details?.workStation,
    },
    projectStages: props.details?.estimationPhase,
  };
}) as any;
const internalInstance = getCurrentInstance();

const projectDetail = computed(() => {
  return {
    ...props.details?.project,
    projectCreator: {
      firstName: user.value?.firstName,
      lastName: user.value?.lastName,
    },
  };
});

const contractorDetails = computed(() => {
  return props.details?.workStation;
});

const isProjectEstimateIdPresent = computed(
  () => !!props.details?.project?.projectEstimateId
);
const isIdMatching = computed(() => {
  const routeId = route.params.estimateId;
  const projectEstimateId = props.details?.project?.projectEstimateId;
  return routeId == projectEstimateId;
});

const onClickBackEstimateButton = () => {
  router.push(`/project-details/${props?.details?.project?.refId}`);
};

const onClickRejectEstimate = () => {
  isRejectEstimate.value = true;
};

const onClickAcceptEstimate = () => {
  isAcceptEstimate.value = true;
};

const onConfirmEstimate = async () => {
  isAcceptEstimate.value = false;
  if (
    emergencyCallOutDetails.value?.type &&
    projectEstimate.value.agreeTermsConsumerDisclosure ===
      AgreeTermsConsumerDisclosure.NOT_ADDED
  ) {
    try {
      acceptEstimateLoader.value = true;
      await projectService.updateProjectStatus(projectDetail.value?.id, {
        projectJobStatusId: ProjectJobStatusEnum.IN_PROGRESS,
      });
      displayToastMessage(
        internalInstance,
        "Estimate Accepted successfully",
        "success"
      );
      acceptEstimateLoader.value = false;
    } catch (error) {
      console.log("error", error);
      acceptEstimateLoader.value = false;
    }
  } else {
    isOpenServiceAgreementModal.value = true;
  }
};

const onCloseRejectEstimate = () => {
  isRejectEstimate.value = false;
};

const onCloseAcceptEstimate = () => {
  isAcceptEstimate.value = false;
};

const onClickServiceAgreementModal = () => {
  isOpenServiceAgreementModal.value = true;
};
const onConfirmRejectEstimate = async (payload: any) => {
  try {
    const data = await projectEstimationService.rejectEstimate(
      props.details?.id,
      payload
    );
  } catch (error) {
    console.log("error", error);
  } finally {
    isRejectEstimate.value = false;
    router.push(`/project-details/${props?.details?.project?.refId}`);
  }
};
const onConfirmServiceAgreement = async () => {
  isOpenServiceAgreementModal.value = false;
  isOpenEstimateDetailsModal.value = true;
};

const onCloseServiceAgreementModal = () => {
  isOpenServiceAgreementModal.value = false;
};

const onCloseEstimateDetailsModal = async () => {
  isOpenEstimateDetailsModal.value = false;
  isEstimateLoading.value = true;

  try {
    loading.value = true;
    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[0];
    }, 1000);
    const payload = { status: AgreeTermsConsumerDisclosure.ACCEPTED };
    (await projectEstimationService.submitStatusWithEstimateUpdate(
      props.details?.project?.id,
      props.details?.id,
      payload
    )) as any;

    isEstimateApproved.value = true;
  } catch (error) {
    console.log("error ", error);
    isEstimateApproved.value = false;
    router.go(-1);
  } finally {
    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[1];
    }, 2000);

    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[2];
      loading.value = false;
    }, 5000);
  }
};
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const projectCreatorDetails = computed(() => {
  return {
    ...projectDetail.value,
    userWorkstation: activeUserWorkstation.value,
  };
});

const onClickBackProject = () => {
  // project refId
  isEstimateApproved.value = false;
  router.push(`/project-details/${props?.details?.project?.refId}`);

  store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    "project-overview"
  );
};
const goToDetailPage = () => {
  router.push(`/trade-estimates/${props.details?.project?.projectEstimateId}`);
};

onBeforeMount(async () => {
  emergencyCallOutDetails.value =
    await JobService.getEmergencyJobCallOutDetails(props.details?.project?.id);
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (isProjectEstimateIdPresent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ErrorRedIcon, { class: "tw-w-[30px] tw-h-[30px]" }),
          _createElementVNode("p", _hoisted_3, [
            (!isIdMatching.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createTextVNode(" An estimate for the project \""),
                  _createElementVNode("strong", null, _toDisplayString(projectName.value), 1),
                  _createTextVNode("\" has already been submitted by the "),
                  _createElementVNode("strong", null, _toDisplayString(workStationName.value), 1),
                  _createTextVNode(" workstation. "),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(goToDetailPage, ["prevent"])
                  }, " View Esimate")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createTextVNode(" An estimate for the project \""),
                  _createElementVNode("strong", null, _toDisplayString(projectName.value), 1),
                  _createTextVNode("\" has already been accepted. ")
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(BackButton, {
        label: "Back to Your Estimates",
        onClick: onClickBackEstimateButton
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Button, {
          class: "!tw-w-[200px]",
          variant: "secondary",
          label: "REJECT ESTIMATE",
          disabled: isProjectEstimateIdPresent.value,
          onClick: onClickRejectEstimate
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          class: "!tw-w-[200px]",
          label: "ACCEPT ESTIMATE",
          disabled: isProjectEstimateIdPresent.value,
          onClick: onClickAcceptEstimate
        }, null, 8, ["disabled"])
      ])
    ]),
    (__props.details)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ContractorDetailsCard, { contractorDetails: contractorDetails.value }, null, 8, ["contractorDetails"]),
              (
              __props.details?.inviteContractors && __props.details?.inviteContractors?.length
            )
                ? (_openBlock(), _createBlock(SubContractorList, {
                    key: 0,
                    class: "desktop__wrapper lg:tw-hidden",
                    subContractorDetailsList: __props.details?.inviteContractors
                  }, null, 8, ["subContractorDetailsList"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(Button, {
              class: "!tw-w-[200px] sm:!tw-w-full",
              variant: "secondary",
              label: "REJECT ESTIMATE",
              onClick: onClickRejectEstimate
            }),
            _createVNode(Button, {
              class: "!tw-w-[200px] sm:!tw-w-full",
              label: "ACCEPT ESTIMATE",
              onClick: onClickAcceptEstimate
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Text, { variant: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.details?.project?.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(CommercialChip),
                _createVNode(LabelWithValue, {
                  justifyStart: true,
                  noBg: true,
                  data: __props.details?.project?.refId,
                  label: "Project ID:"
                }, null, 8, ["data"])
              ])
            ]),
            _createVNode(_component_v_divider),
            (
            emergencyCallOutDetails.value ||
            __props.details?.project?.type === _unref(ProjectTypesEnum).VIDEO_CONSULTATION
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (emergencyCallOutDetails.value?.type === _unref(ProjectTypesEnum).EMERGENCY)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("p", null, "£" + _toDisplayString(emergencyCallOutDetails.value.emergencyCallOutFee), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("p", null, " £" + _toDisplayString(emergencyCallOutDetails.value.emergencyCallOutRate) + " / hour ", 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
              __props.details?.project?.type === _unref(ProjectTypesEnum).VIDEO_CONSULTATION
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("p", null, " £" + _toDisplayString(__props.details?.estimationPhase[0]?.videoConsulationFee) + " / hour ", 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", null, _toDisplayString(__props.details?.suggestedStartDate), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("p", null, _toDisplayString(__props.details?.estimationPhase[0].startTime) + " To " + _toDisplayString(__props.details?.estimationPhase[0].endTime), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider, { class: "tw-my-3" }),
                  _createElementVNode("div", null, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("p", {
                        innerHTML: emergencyCallOutDetails.value.notes
                      }, null, 8, _hoisted_31)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(EstimateReceivedSummaryCard, { selectedEstimate: __props.details }, null, 8, ["selectedEstimate"])
          ]),
          _createVNode(SubContractorList, {
            class: "mobile__wrapper tw-hidden lg:tw-block lg:tw-text-left",
            subContractorDetailsList: __props.details?.inviteContractors
          }, null, 8, ["subContractorDetailsList"])
        ]))
      : _createCommentVNode("", true),
    (isAcceptEstimate.value)
      ? (_openBlock(), _createBlock(AcceptProjectEstimateModal, {
          key: 2,
          isLoading: acceptEstimateLoader.value,
          onOnSave: onConfirmEstimate,
          onOnClose: onCloseAcceptEstimate
        }, null, 8, ["isLoading"]))
      : _createCommentVNode("", true),
    (isOpenServiceAgreementModal.value)
      ? (_openBlock(), _createBlock(ServiceAgreementModal, {
          key: 3,
          project: projectCreatorDetails.value,
          projectEstimate: projectEstimate.value,
          type: "property",
          onOnConfirm: onConfirmServiceAgreement,
          onOnClose: onCloseServiceAgreementModal
        }, null, 8, ["project", "projectEstimate"]))
      : _createCommentVNode("", true),
    (isRejectEstimate.value)
      ? (_openBlock(), _createBlock(RejectProjectEstimateModal, {
          key: 4,
          projectId: __props.details?.project?.id,
          projectEstimateId: __props.details?.id,
          onOnConfirm: onConfirmRejectEstimate,
          onOnCancel: onCloseRejectEstimate
        }, null, 8, ["projectId", "projectEstimateId"]))
      : _createCommentVNode("", true),
    (isOpenEstimateDetailsModal.value)
      ? (_openBlock(), _createBlock(EstimateDetailsModal, {
          key: 5,
          onOnClose: onCloseEstimateDetailsModal,
          projectEstimateId: __props.details?.id
        }, null, 8, ["projectEstimateId"]))
      : _createCommentVNode("", true),
    (isEstimateApproved.value)
      ? (_openBlock(), _createBlock(EstimateApproveModal, {
          key: 6,
          estimateData: __props.details,
          onOnBackProject: onClickBackProject,
          onOnDeposit: onClickBackProject
        }, null, 8, ["estimateData"]))
      : _createCommentVNode("", true),
    (isEstimateLoading.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 7,
          width: "500px",
          modelValue: loading.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
          class: "modal_box action-modal",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("main", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("p", _hoisted_35, _toDisplayString(switchingText.value), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("img", {
                      src: require('@/assets/icons/estimate-loader.svg'),
                      alt: ""
                    }, null, 8, _hoisted_37)
                  ]),
                  _createVNode(_component_v_stepper, {
                    class: "onboard-stepper",
                    modelValue: currentSelectedTab.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSelectedTab.value.name) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabListItems.value, (step, index) => {
                            return (_openBlock(), _createBlock(_component_v_stepper_item, {
                              class: "onboard-stepper__item",
                              key: index,
                              value: step.name
                            }, null, 8, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})